import React, { useEffect } from 'react'
// import ContentHolder from 'components/layouts/ContentHolder'
import MigrateModal from './MigrateModal'


const Migrate = () => {

  useEffect(() => {
  }, [])

  return (
    <>
      <div className="page--account">
        {/* <ContentHolder> */}
            <MigrateModal />
        {/* </ContentHolder> */}
      </div>
    </>
  )
}

export default Migrate
